<script setup lang="ts">
import { useCountAuctionVisit } from '@autobid/ui/composables/car/useCountAuctionVisit'
import { useAuction } from '@autobid/ui/composables/useAuction'
import { onServerPrefetch } from 'vue'

interface Props {
  auctionId: number
}

const props = defineProps<Props>()
const { auction, suspense } = useAuction(props.auctionId)
onServerPrefetch(suspense)

const { handleCountVisitation } = useCountAuctionVisit()

handleCountVisitation()
</script>

<template>
  <div class="w-full">
    <div
      v-if="auction?.publicationInfo.status === 'WITHDRAW'"
    >
      <autobid-page
        :slug="
          auction.stage === 'FINISHED'
            ? 'auction-in-preparation-finished'
            : 'auction-in-preparation'
        "
        ignore-blacklist
        :allow-empty="true"
      >
        <template #default="{ pageData }">
          <CommonStrapiPage v-if="pageData?.page" :page-data="pageData" />

          <SectionsAuctionInPreparationInfo v-else />
        </template>
      </autobid-page>
    </div>
    <div v-else-if="auction" class="w-full">
      <slot />
    </div>
  </div>
</template>
